import { useLocalStorage } from "@src/appV2/lib/utils";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

function getWorkerSavingsDataStorageKey(workerId: string) {
  return `worker-savings-data-${workerId}`;
}

export const useWorkerSavingsData = () => {
  const worker = useDefinedWorker();
  const workerSavingsDataStorageKey = getWorkerSavingsDataStorageKey(worker.userId);
  const [workerSavingsData, setWorkerSavingsData] = useLocalStorage(workerSavingsDataStorageKey, {
    savingsOnboardingCompleted: false,
    savingsGoal: 0,
    savingsAmount: 0,
    savingsReason: "",
    savingsPercent: 0,
    savingsAmountPerShift: 0,
    shiftsPerMonth: 4,
    weeksPerSimulation: 10,
  });

  return {
    workerSavingsData,
    setWorkerSavingsData,
  };
};
